module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("First published in the United States in 2013 by Chronicle Books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("First Published in the United Kingdom in 2011 by Hodder & Stoughton, an Hachette UK company.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Text and illustrations copyright")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2013 by Andy Riley.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("ISBN 978-1-4521-2692-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("The Library of Congress has cataloged the previous edition as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Riley, Andy.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Beer makes daddy strong / Andy Riley.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightc"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("ISBN 978-1-4521-1208-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta1"
  }, [_vm._v("1. English wit and humor, Pictorial. 2. Fathers--Caricatures and cartoons. 3. Fatherhood--Caricatures and cartoons. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightat"
  }, [_vm._v("NC1479.R55A4 2013b")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("741.5’6941--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightr"
  }, [_vm._v("2012026429")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Chronicle Books, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("680 Second Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("San Francisco, California 94107")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0